import { StyleSheet } from 'react-native';
import { themes } from '../../../../theme/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: themes.light.white[1],
  },
  scrollableTextContainer: {
    flex: 1,
    marginBottom: 16,
    padding: 8,
    borderWidth: 1,
    borderColor: themes.light.gray_blue[4],
    borderRadius: 8,
    backgroundColor: themes.light.gray_blue[6],
  },
  checkboxContainer: {
    flexDirection: 'row',
    gap: 16,
  },
});
